import Layout from 'components/layout/Layout'
import { useUser } from 'contexts/UserContext'
import Dashboard from 'pages/Dashboard/Dashboard'
import Login from 'pages/Login/Login'
import Logout from 'pages/Login/Logout'
import PropTypes from 'prop-types'
import { ToastContainer } from 'react-toastify'
import { Redirect, Route, Switch } from 'wouter'
import UserViewDetail from './User/UserViewDetail'
import UserViewGrid from './User/UserViewGrid'
import ContractesPage from './Contractes/ContractesPage'
import HistoricPage from './Contractes/HistoricPage'

// Rutas privadas que se pueden usar si se ha iniciado sesión:
const PrivateRoute = ({ isLoggedIn, ...props }) =>
  isLoggedIn ? (
    <Layout>
      <Route {...props} />
    </Layout>
  ) : (
    <Redirect to="/login" />
  )

// Ruta 'LOG IN' que se usa si no se ha iniciado sesión:
const LoginRoute = ({ isLoggedIn, ...props }) =>
  isLoggedIn ? <Redirect to="/" /> : <Route path="/login" component={Login} />

export default function App() {
  // Hook para gestionar el usuario actual
  const { user } = useUser()
  const isLoggedIn = user && !!user.token

  return (
    <>
      <Switch>
        {/* INICIO SESIÓN / CIERRE SESIÓN */}
        <LoginRoute isLoggedIn={isLoggedIn} path="/login" component={Login} />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/logout"
          component={Logout}
        />
        {/* FIN INICIO SESIÓN / CIERRE SESIÓN */}

        {/* PANEL PRINCIPAL */}
        <PrivateRoute isLoggedIn={isLoggedIn} path="/" component={Dashboard} />
        {/* FIN PANEL PRINCIPAL */}

        {/* USUARIOS */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/users/grid"
          component={UserViewGrid}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/users/:id"
          component={UserViewDetail}
        />
        {/* FIN USUARIOS */}

        {/* CONTRACTES MENORS */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/contractes"
          component={ContractesPage}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/contractes/editar/:id"
          component={ContractesPage}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/contractes/historic"
          component={HistoricPage}
        />
        {/* FIN CONTRACTES MENORS */}
      </Switch>

      {/* 
        'ToastContainer' es un contenedor para mostrar mensajes flotantes, generalmente se usa para mensajes de éxito o error tras llamadas a la API. 
        No mover de aquí, ya que aquí funciona correctamente. Si lo pones en otro lugar de la app el botón de cerrar o las animaciones no funcionan. 
        Los toasts se crean y se referencian automáticamente a este componente para mostrarse. 
        Para más info: https://fkhadra.github.io/react-toastify/introduction/
      */}
      <ToastContainer />
    </>
  )
}

PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool
}

LoginRoute.propTypes = {
  isLoggedIn: PropTypes.bool
}
